import type {
  DataTableDataSelectableEvent,
  DataTableSelectionCellMultipleChangeEvent,
  DataTableValueArray,
} from 'primereact/datatable';
import { DataTable as PrimeReactDataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import type { DataTableCellPreSelection, DataTableColumn, DataTableSelection } from './data-table';
import { useEffect, useState } from 'react';

export interface DataTableProps {
  data: DataTableValueArray;
  columns: Array<DataTableColumn>;
  preSelected?: Array<DataTableCellPreSelection>;
  onSelectionChange?: (selections: Array<DataTableSelection>) => void;
  onModifySelection?: (selections: Array<DataTableSelection>) => Array<DataTableSelection>;
  handleIsDataSelectable?: (field: string) => boolean;
}

function DataTable({
  data,
  columns,
  preSelected,
  onSelectionChange,
  onModifySelection,
  handleIsDataSelectable,
}: DataTableProps) {
  const [selection, setSelection] = useState<Array<DataTableSelection> | null>(null);

  useEffect(() => {
    setSelection((preSelected ?? []) as Array<DataTableSelection>);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Mount-only effect to initialize selection from preSelected prop
  }, []);

  const onDataSelectionChange = (event: DataTableSelectionCellMultipleChangeEvent<DataTableValueArray>) => {
    const selection = onModifySelection?.(event.value) ?? event.value;
    setSelection(selection);
    onSelectionChange?.(selection);
  };

  const isDataSelectable = (event: DataTableDataSelectableEvent) => {
    return handleIsDataSelectable?.(event.data.field) ?? true;
  };

  return (
    <PrimeReactDataTable
      value={data}
      selection={selection}
      onSelectionChange={onDataSelectionChange}
      isDataSelectable={isDataSelectable}
      metaKeySelection={false}
      scrollable
      scrollHeight="100%"
      stripedRows
      className="odin datatable-selectable"
      selectionMode="multiple"
      dataKey="id"
      cellSelection
    >
      {columns.map((column) => (
        <Column key={column.field} field={column.field} header={column.header} body={column.customCell} />
      ))}
    </PrimeReactDataTable>
  );
}

export default DataTable;
